const store = {
    namespaced: true,
    state() {
        return {
            newest: [],
            populars: [],
            all: []
        }
    },
    getters: {
        getNewestArticles(state) {
            return state.newest
        },
        getPopularsArticles(state) {
            return state.populars
        }
    },
    mutations: {
        setNewestArticles(state, articles) {
            state.newest = articles
        },
        setPopularArticles(state, articles) {
            state.populars = articles
        }
    }
}

export default store